export default "__VITE_PUBLIC_ASSET__d0926806__"